import {
	SalesChannelEntrySchema,
	type SalesChannelEntry,
} from '#app/routes/mocra+/_form+/components/sales-channels/schema.ts'
import {
	collectSalesChannelErrors,
	createSalesChannelDraft,
	sanitizeSalesChannelDraft,
	type SalesChannelDraft,
} from '#app/routes/mocra+/_form+/components/sales-channels/types.ts'
import { assertEntityDefinition } from '#app/routes/mocra+/_form+/entity-definition.ts'

export const salesChannelDefinition = assertEntityDefinition<
	SalesChannelEntry,
	SalesChannelDraft
>({
	schema: SalesChannelEntrySchema,
	createDraft: () => createSalesChannelDraft(),
	sanitizeDraft: sanitizeSalesChannelDraft,
	serialize: (draft) => {
		const sanitized = sanitizeSalesChannelDraft(draft)
		return {
			type: sanitized.type,
			name: sanitized.name,
		}
	},
	deserialize: (entry) =>
		sanitizeSalesChannelDraft(
			createSalesChannelDraft({
				type: entry.type as SalesChannelDraft['type'],
				name: entry.name,
			}),
		),
	collectErrors: collectSalesChannelErrors,
})

export type SalesChannelEntityDraft = SalesChannelDraft
